import { render, staticRenderFns } from "./DialogAddDefaultClientPayment.vue?vue&type=template&id=08ccbd4f"
import script from "./DialogAddDefaultClientPayment.vue?vue&type=script&lang=js"
export * from "./DialogAddDefaultClientPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports